import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 607.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">


<path d="M4797 6452 c-198 -256 -231 -298 -241 -314 -17 -28 -31 -22 -69 30
-19 26 -55 72 -79 103 -23 31 -78 101 -121 157 l-78 102 -464 0 c-255 0 -470
-3 -479 -6 -9 -3 -16 -12 -16 -20 0 -8 66 -92 148 -187 81 -95 187 -222 237
-282 49 -61 98 -119 107 -130 10 -11 17 -24 18 -29 0 -4 -63 -7 -139 -7 -175
2 -167 11 -164 -179 l3 -135 -28 31 c-15 16 -39 46 -55 65 -15 18 -62 76 -105
126 l-77 93 -202 0 c-227 0 -223 1 -223 -76 l0 -38 -27 26 c-16 14 -48 36 -73
49 -45 24 -46 24 -410 24 l-365 0 -49 -28 -49 -27 -27 25 -27 26 -244 6 c-134
3 -307 1 -384 -5 -119 -8 -148 -13 -191 -35 -27 -14 -56 -33 -63 -41 -17 -20
-45 -21 -38 -2 3 8 -7 33 -23 55 l-30 40 -190 -4 c-105 -3 -199 -9 -210 -15
-10 -6 -32 -27 -47 -47 -28 -36 -28 -38 -31 -207 -2 -93 1 -345 7 -560 l11
-390 37 -33 38 -33 222 0 222 0 3 85 3 85 26 -24 c39 -36 100 -64 166 -75 70
-12 725 -36 747 -28 12 5 16 21 16 63 l0 57 22 -20 c13 -11 43 -31 68 -44 45
-24 46 -24 395 -23 329 0 353 2 395 21 25 11 56 32 70 46 14 15 28 27 33 27 4
0 7 -27 7 -60 l0 -60 143 0 c157 -1 162 -7 25 -40 -367 -87 -791 -72 -1108 38
-10 3 -12 2 -5 -5 16 -17 252 -101 360 -128 227 -58 315 -68 675 -72 438 -6
704 18 889 82 41 14 75 25 77 25 1 0 19 -27 40 -60 36 -55 42 -60 75 -60 39 0
45 5 249 240 46 52 112 126 148 164 l65 70 16 -24 c9 -14 93 -120 186 -237
l170 -212 200 -4 c110 -3 343 -2 518 2 l318 6 -85 110 c-48 61 -114 146 -148
190 -34 44 -86 110 -115 148 -29 37 -78 99 -108 137 -97 124 -170 215 -175
220 -24 23 -210 271 -210 280 0 9 91 121 130 160 10 10 255 298 302 355 9 11
43 52 75 91 32 39 94 117 138 174 44 57 85 108 90 114 48 52 105 125 105 135
0 8 -126 11 -477 11 l-478 0 -68 -88z m886 32 c3 -3 -74 -95 -171 -203 -367
-409 -428 -478 -552 -628 -14 -17 -61 -70 -106 -119 -44 -49 -125 -138 -180
-199 -54 -60 -101 -112 -104 -115 -3 -3 -38 -43 -79 -90 -41 -47 -84 -95 -95
-106 -38 -39 -71 -78 -160 -184 -84 -100 -254 -275 -261 -268 -15 18 -33 68
-24 68 7 0 9 9 5 24 -7 28 11 46 20 22 3 -9 10 -16 15 -16 4 0 6 7 3 15 -4 10
-2 13 8 10 21 -8 15 82 -7 104 -14 14 -18 13 -45 -16 -16 -17 -28 -38 -27 -45
2 -7 2 -10 0 -5 -8 12 -27 8 -58 -13 l-30 -21 28 7 c81 19 -27 -42 -168 -94
-142 -53 -352 -105 -535 -133 -117 -18 -184 -22 -344 -20 -110 1 -202 4 -205
6 -2 3 38 5 90 5 52 0 135 5 184 10 252 29 585 123 585 166 0 16 17 19 22 4 2
-5 18 0 36 12 23 14 31 26 27 38 -4 12 13 31 65 70 132 97 318 295 298 315 -2
2 -32 -23 -68 -56 -219 -201 -297 -261 -454 -344 -114 -61 -159 -79 -259 -104
-73 -19 -104 -12 -34 8 117 33 309 133 443 231 69 51 212 191 275 271 24 31
94 112 154 181 100 115 125 133 125 93 0 -5 -4 -4 -9 4 -6 9 -11 10 -15 2 -14
-22 6 -33 26 -14 29 26 204 246 229 287 26 44 8 57 -27 19 -14 -15 -5 1 20 37
119 168 198 277 214 295 10 11 42 52 72 90 29 39 77 99 105 135 28 36 79 101
114 145 34 44 69 88 76 97 13 15 44 17 316 18 167 0 305 2 307 5 8 7 148 6
155 -1z m-1473 -56 c17 -24 37 -52 44 -63 52 -73 193 -265 213 -289 13 -16 23
-36 21 -44 -3 -18 -68 -36 -68 -19 0 5 -12 25 -26 44 -23 31 -28 33 -43 20
-17 -15 -25 -15 -106 3 -27 6 -66 13 -85 16 -18 2 -50 14 -70 25 -40 24 -137
52 -151 44 -4 -3 -21 0 -36 8 -15 8 -44 17 -64 20 -20 3 -69 26 -110 51 -41
26 -75 42 -77 36 -2 -6 41 -63 95 -126 200 -237 343 -414 343 -426 0 -5 -34
31 -77 81 -88 105 -158 182 -148 162 4 -7 2 -18 -6 -23 -11 -8 -10 -9 4 -4 11
4 16 2 11 -5 -3 -6 3 -20 14 -32 11 -12 25 -33 31 -47 10 -20 6 -18 -19 10
-18 19 -54 58 -80 85 -55 58 -109 151 -67 117 7 -6 18 -8 24 -4 14 9 3 23
-168 232 -81 99 -98 114 -158 137 -14 5 -21 12 -15 15 5 3 25 -2 44 -13 19
-10 41 -21 49 -25 9 -4 17 -2 19 4 2 7 20 13 40 13 l37 2 -35 7 c-19 4 -33 8
-30 10 11 5 285 17 447 18 l173 2 30 -42z m-3496 -620 c1 -2 0 -247 -2 -545
l-3 -543 -140 0 c-105 0 -145 -4 -162 -15 -49 -32 -49 -36 -48 526 l2 524 25
25 c20 21 37 26 102 30 72 5 224 4 226 -2z m976 -48 c-6 -19 -10 -85 -10 -147
l0 -112 -251 -3 c-250 -3 -251 -3 -270 -27 -17 -21 -19 -41 -19 -211 0 -177 1
-188 21 -206 19 -17 42 -19 270 -23 l249 -3 0 -143 0 -143 -222 -7 c-123 -4
-275 -5 -339 -4 -105 4 -121 7 -174 34 -71 36 -118 94 -140 170 -13 45 -16
104 -13 347 3 292 3 293 29 349 16 34 43 69 70 91 77 62 107 67 469 75 179 5
328 6 332 3 4 -3 3 -21 -2 -40z m2178 -241 l2 -286 -87 -90 c-57 -58 -106 -99
-140 -115 -29 -15 -53 -21 -53 -16 0 6 -12 8 -29 5 -15 -3 -33 -1 -39 5 -7 7
-15 9 -18 5 -4 -3 12 -27 34 -53 42 -49 44 -62 14 -81 -16 -9 -40 16 -197 213
-98 123 -180 224 -182 224 -2 0 -3 -129 -3 -286 1 -157 -1 -289 -5 -292 -4 -4
-69 -7 -146 -7 -104 0 -140 3 -144 13 -2 7 -5 243 -5 525 l-1 512 154 3 153 2
188 -235 c104 -129 192 -235 195 -235 3 0 4 105 1 232 -3 128 -4 236 -2 241 2
4 72 6 155 5 l152 -3 3 -286z m-1221 260 c24 -11 58 -39 77 -61 62 -72 68
-103 73 -399 7 -360 -5 -429 -90 -511 -63 -61 -98 -66 -442 -70 l-300 -3 -60
30 c-67 34 -117 91 -137 158 -9 30 -13 128 -13 347 0 351 5 376 81 451 75 74
103 78 458 79 294 0 312 -1 353 -21z m1503 -123 c0 -6 -11 2 -25 18 -32 37
-32 46 0 16 14 -13 25 -28 25 -34z m-141 -76 c33 -41 61 -79 61 -83 0 -10
-122 -157 -131 -157 -3 0 -7 72 -8 161 -1 99 1 160 7 158 5 -2 37 -38 71 -79z
m1042 -293 c57 -71 125 -158 152 -193 26 -35 91 -120 145 -189 53 -68 126
-163 162 -211 36 -47 70 -91 75 -98 6 -6 27 -32 48 -59 l38 -47 -158 2 c-101
0 -142 4 -113 8 25 4 40 8 34 8 -7 1 -14 10 -17 21 -3 13 -19 20 -58 27 -51 8
-48 9 60 14 l113 5 -51 64 c-49 61 -64 90 -39 75 7 -4 8 -3 4 4 -4 6 -13 9
-20 6 -7 -3 -30 17 -54 48 -69 90 -113 133 -122 119 -6 -10 -18 -11 -51 -3
-92 22 -152 41 -168 55 -9 8 -23 16 -31 19 -8 3 -39 25 -68 48 -41 33 -53 48
-49 64 3 12 12 48 20 81 8 33 18 77 22 97 4 29 9 36 22 31 11 -4 6 9 -15 40
-18 25 -32 51 -32 57 0 16 23 40 36 37 6 -1 58 -60 115 -130z m-3371 -72 l0
-125 -225 0 -225 0 0 118 c0 65 3 122 7 125 3 4 105 7 225 7 l218 0 0 -125z
m1664 -310 c42 -49 76 -95 76 -100 0 -6 -10 -17 -22 -24 -36 -23 -140 -81
-144 -81 -2 0 -4 71 -4 157 0 98 4 153 9 148 6 -6 44 -50 85 -100z m1274 3 c9
-9 12 -9 12 0 0 24 99 14 182 -20 77 -30 99 -48 113 -95 5 -19 0 -26 -30 -40
-40 -19 -52 -48 -38 -90 6 -16 9 -40 9 -55 -1 -14 2 -24 6 -22 4 3 8 0 8 -5 0
-7 41 -11 117 -11 64 0 114 -2 112 -4 -2 -2 -53 -7 -114 -9 -60 -3 -111 -6
-112 -6 -2 -1 -3 -14 -3 -31 0 -25 -4 -30 -25 -30 -14 0 -25 1 -25 3 0 1 4 17
10 36 8 29 6 38 -18 70 -44 58 -82 80 -82 46 0 -28 -16 -15 -67 53 -71 95 -78
109 -53 117 26 8 25 13 -5 57 -14 20 -25 39 -25 42 0 10 16 6 28 -6z m-1608
-357 c0 -11 -102 -31 -149 -30 -25 1 -11 6 49 19 47 10 88 18 93 19 4 0 7 -3
7 -8z"/>
<path d="M4926 6377 c-39 -42 -197 -250 -224 -297 l-21 -35 97 0 c99 1 161 15
195 46 10 9 42 28 72 43 55 27 82 28 138 7 14 -6 28 -7 32 -3 4 4 4 -3 1 -15
-5 -17 -3 -21 10 -19 20 3 104 85 104 102 0 17 -27 37 -39 29 -7 -3 -8 0 -5 9
3 9 1 16 -5 16 -6 0 -27 10 -45 22 -28 18 -36 31 -41 68 -4 25 -12 48 -18 52
-7 4 -59 8 -116 8 l-104 0 -31 -33z"/>
<path d="M5006 5919 c-98 -106 -109 -131 -30 -73 33 24 111 131 102 139 -3 3
-35 -27 -72 -66z"/>
<path d="M4496 5814 c-20 -25 -33 -51 -29 -57 3 -5 1 -7 -5 -3 -13 8 -64 -56
-53 -67 15 -15 42 4 35 26 -5 16 -3 19 10 14 11 -5 18 2 25 26 5 18 10 26 10
18 1 -17 23 -1 51 39 17 24 18 30 6 39 -12 10 -21 3 -50 -35z"/>
<path d="M4359 5643 c-31 -35 -70 -82 -279 -347 -38 -49 -70 -90 -70 -92 0 -2
20 -1 45 1 49 4 66 15 170 114 33 31 79 71 101 89 61 47 97 84 113 114 12 24
12 34 -6 90 -12 34 -25 64 -30 65 -5 2 -25 -14 -44 -34z"/>
<path d="M4478 5382 c-237 -233 -376 -362 -450 -419 -20 -15 -63 -48 -95 -73
-134 -103 -338 -219 -543 -308 -56 -24 17 -11 125 22 155 48 237 80 319 125
70 39 245 186 300 252 68 82 231 239 243 234 9 -3 13 1 11 12 -2 9 5 17 15 18
9 2 17 0 17 -4 0 -4 12 -13 27 -20 25 -11 30 -10 48 12 11 13 52 62 90 108
142 169 162 199 134 199 -5 0 -7 5 -4 10 13 21 23 70 15 70 -5 0 -118 -107
-252 -238z"/>
<path d="M4414 5092 c-45 -43 -148 -162 -157 -180 -8 -16 25 18 64 64 9 10 29
31 45 45 16 15 36 35 44 45 8 11 21 27 29 37 21 26 7 20 -25 -11z"/>
<path d="M3742 4975 c-7 -8 -9 -15 -4 -15 5 0 15 7 22 15 16 19 -1 19 -18 0z"/>
<path d="M3680 4910 c-18 -16 -29 -30 -24 -30 9 1 72 60 62 60 -2 0 -20 -13
-38 -30z"/>
<path d="M4045 4870 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3586 4835 c-11 -8 -17 -17 -14 -20 2 -3 13 4 23 15 21 23 18 25 -9
5z"/>
<path d="M3995 4821 c-6 -11 13 -26 22 -17 4 3 1 6 -6 6 -7 0 -9 5 -6 10 3 6
4 10 1 10 -3 0 -7 -4 -11 -9z"/>
<path d="M410 4928 c0 -50 11 -83 21 -66 6 9 9 7 9 -9 0 -13 5 -23 10 -23 6 0
10 -8 10 -19 0 -15 10 -19 53 -25 28 -3 73 -6 100 -6 l47 0 0 93 c0 50 -4 87
-8 81 -4 -6 -40 -12 -82 -12 -97 -1 -123 -5 -132 -17 -4 -5 -8 0 -8 13 0 12
-4 22 -10 22 -5 0 -10 -15 -10 -32z"/>
<path d="M691 4864 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M866 4920 c10 -40 32 -68 76 -98 l41 -27 271 -1 c149 -1 260 0 246 3
-14 3 -29 9 -34 14 -6 5 -21 9 -33 9 -13 0 -36 6 -51 14 -15 8 -53 17 -85 21
-31 4 -60 11 -63 16 -3 5 -15 9 -28 9 -13 0 -68 11 -122 24 -54 13 -125 23
-157 22 -31 0 -59 4 -62 9 -3 6 -2 -1 1 -15z"/>
<path d="M2927 5007 c-4 -10 -7 -61 -7 -113 l0 -94 105 0 105 0 0 91 c0 61 -3
88 -11 84 -5 -4 -41 1 -80 10 -38 9 -75 15 -83 12 -9 -4 -16 1 -18 11 -3 15
-4 15 -11 -1z"/>
<path d="M2950 4770 c-11 -7 -7 -10 18 -10 17 0 32 5 32 10 0 13 -30 13 -50 0z"/>
<path d="M2122 5477 c-21 -22 -22 -32 -22 -215 0 -247 -12 -232 180 -232 127
0 142 2 160 20 23 23 23 20 21 240 -2 163 -2 165 -27 188 -23 20 -34 22 -158
22 -126 0 -134 -1 -154 -23z m258 -146 c5 -11 10 -61 10 -111 0 -129 -1 -130
-109 -130 -104 0 -101 -5 -101 133 0 124 2 127 105 127 73 0 86 -3 95 -19z"/>
<path d="M2711 4923 c-7 -8 -10 -17 -7 -20 9 -9 29 13 25 25 -2 6 -10 3 -18
-5z"/>
<path d="M1830 4902 c0 -23 79 -91 117 -101 51 -15 581 -14 637 0 48 12 120
65 110 81 -7 12 -55 6 -99 -13 -35 -14 -85 -13 -135 3 -21 7 -109 11 -220 11
-111 -1 -193 3 -205 10 -11 5 -61 13 -112 16 -73 5 -93 3 -93 -7z m845 -32
c-3 -5 -11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z"/>
<path d="M640 4139 l0 -201 123 4 c134 5 170 16 220 71 52 58 58 137 16 219
-24 48 -62 73 -110 73 -37 0 -89 -21 -89 -36 0 -5 19 -14 41 -21 67 -20 94
-82 68 -156 -12 -35 -60 -62 -112 -62 l-34 0 -7 83 c-9 117 -11 123 -48 121
-41 -3 -46 -10 -51 -74 -2 -30 -4 -2 -3 63 1 64 -2 117 -6 117 -5 0 -8 -91 -8
-201z"/>
<path d="M683 4333 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4757 4327 c-57 -11 -127 -72 -146 -126 -52 -157 88 -304 249 -261
38 10 111 63 100 72 -3 2 -20 16 -38 31 l-33 27 -21 -20 c-34 -31 -93 -27
-129 9 -24 24 -29 38 -29 76 0 59 13 83 54 100 35 15 67 11 104 -13 20 -13 25
-13 44 4 52 45 52 44 32 60 -55 42 -112 55 -187 41z"/>
<path d="M1079 4150 c-1 -99 -2 -186 -3 -192 -1 -9 16 -13 52 -13 28 0 52 3
52 8 0 4 0 90 0 192 l0 185 -50 0 -50 0 -1 -180z"/>
<path d="M1677 4188 c-4 -79 -7 -167 -7 -195 l0 -53 55 0 55 0 0 195 0 195
-48 0 -49 0 -6 -142z"/>
<path d="M1827 4298 c-7 -46 1 -53 58 -53 l50 0 -4 -152 -4 -153 56 0 56 0 3
153 3 152 53 3 52 3 0 40 0 39 -159 0 -159 0 -5 -32z"/>
<path d="M2263 4303 c-6 -16 -40 -102 -77 -191 -36 -90 -66 -166 -66 -168 0
-2 25 -4 55 -4 54 0 54 0 61 35 l6 35 78 0 77 0 9 -32 c9 -32 12 -33 67 -36
31 -2 57 -1 57 1 0 2 -23 59 -51 128 -60 144 -89 217 -96 242 -4 13 -16 17
-57 17 -47 0 -53 -2 -63 -27z m81 -132 c22 -68 21 -71 -24 -71 -22 0 -40 2
-40 4 0 3 20 62 35 104 7 20 12 14 29 -37z"/>
<path d="M2570 4263 c0 -38 -3 -125 -7 -195 l-6 -128 147 0 147 0 -3 43 -3 42
-85 5 -85 5 -3 148 -3 147 -49 0 -50 0 0 -67z"/>
<path d="M3101 4312 c-19 -10 -43 -34 -54 -54 -19 -32 -20 -40 -9 -77 14 -44
45 -66 130 -92 56 -16 73 -36 47 -56 -23 -17 -77 -10 -114 14 -23 15 -26 14
-48 -11 -29 -34 -29 -52 0 -70 43 -28 110 -39 169 -27 88 19 132 83 108 156
-13 39 -43 61 -113 82 -29 8 -58 20 -64 25 -21 17 -15 37 12 44 22 5 43 1 97
-21 13 -5 23 2 38 27 11 18 20 36 20 39 0 4 -18 14 -40 23 -54 22 -137 21
-179 -2z"/>
<path d="M3380 4242 c0 -49 -3 -137 -7 -195 l-6 -107 146 0 147 0 0 45 0 44
-87 3 -88 3 0 30 0 30 75 0 c54 0 75 4 74 13 -1 6 -2 26 -2 42 l-2 30 -75 0
-75 0 0 30 0 30 90 0 90 0 0 45 0 45 -140 0 -140 0 0 -88z"/>
<path d="M3711 4135 l-2 -195 56 0 56 0 -2 38 c-4 80 -1 94 22 90 15 -2 31
-23 53 -65 l31 -62 63 -1 c48 0 61 3 56 13 -5 6 -25 39 -45 71 l-38 59 29 27
c72 67 40 182 -56 209 -22 6 -80 11 -130 11 l-91 0 -2 -195z m207 68 c4 -38
-21 -56 -71 -51 -30 3 -32 6 -35 46 l-3 43 53 -3 c52 -3 53 -4 56 -35z"/>
<path d="M4054 4288 c7 -24 34 -101 59 -173 25 -71 48 -140 52 -152 6 -20 13
-23 61 -23 50 0 55 2 65 28 17 42 120 325 126 345 5 16 0 18 -48 15 l-53 -3
-37 -105 c-21 -58 -40 -114 -44 -125 -5 -14 -18 15 -48 105 l-42 125 -52 3
-52 3 13 -43z"/>
<path d="M4450 4135 l0 -195 55 0 55 0 -1 195 -1 195 -54 0 -54 0 0 -195z"/>
<path d="M4990 4135 l0 -195 145 0 145 0 0 45 0 45 -91 0 -90 0 3 33 c3 29 6
32 33 30 17 -1 49 0 73 3 41 5 42 6 42 45 l0 39 -75 0 -75 0 0 30 0 30 90 0
90 0 0 45 0 45 -145 0 -145 0 0 -195z"/>
<path d="M5385 4316 c-59 -26 -85 -82 -65 -142 13 -38 52 -65 122 -84 61 -16
80 -37 53 -56 -26 -19 -54 -18 -100 6 l-40 21 -27 -33 c-16 -18 -28 -36 -28
-41 0 -13 83 -46 133 -53 116 -16 214 75 175 162 -17 38 -40 55 -112 80 -65
22 -91 48 -66 64 22 14 56 12 97 -5 20 -8 37 -14 38 -13 0 2 9 15 18 30 9 15
17 32 17 38 0 34 -154 53 -215 26z"/>
<path d="M1455 4305 c-27 -7 -63 -18 -79 -24 -16 -6 -37 -9 -47 -6 -11 4 -19
2 -19 -4 0 -6 -7 -11 -15 -11 -24 0 -55 -73 -55 -129 0 -86 30 -135 104 -173
50 -26 150 -21 219 9 l47 22 0 85 0 86 -80 0 c-57 0 -80 -4 -81 -12 -6 -62 -5
-63 34 -66 70 -6 31 -52 -44 -52 -62 0 -99 45 -99 123 0 85 90 128 170 81 30
-18 30 -18 59 12 l30 31 -45 21 c-24 12 -46 22 -47 21 -1 -1 -24 -7 -52 -14z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
